$(function() {
  $('#toc').on('show.bs.collapse', function() {
    $('.p-table-of-contents button').text('[閉じる]')
  }).on('hide.bs.collapse', function() {
    $('.p-table-of-contents button').text('[開く]')
  })
})